/**
 * 菜单路由控制
 */

//菜单常量
/**
 * hasNewNum: 新增数量标记store方法名
 * isNew：新选项标记
 * hasShow：是否显示该选项规则
 */
const menuOptions = [
        {
            id: 1,
            name: "Transfer",
            menus: [
                {
                    id: 100,
                    name: 'taskList',
                    icon: 'taskList',
                    path: "/mc_project/task_list",
                    hasNewNum: 'getTaskListAddNewNumber',
                },
                {
                    id: 101,
                    name: 'cloudTransfer',
                    icon: 'cloudTransfer',
                    path: "/mc_project/cloud_transfer",
                },
                {
                    id: 102,
                    name: 'teamTransfer',
                    icon: 'teamTransfer',
                    path: "/mc_project/team_transfer",
                },
                {
                    id: 103,
                    name:  'cloudSync',
                    icon: 'cloudsync',
                    path: "/mc_project/cloud_sync",
                },
                {
                    id: 104,
                    name: 'cloudBackup',
                    icon:'cloudbackup',
                    path: "/mc_project/cloud_backup",
                },
                {
                    id: 105,
                    name: 'btLink',
                    icon: 'linkTask',
                    path: "/mc_project/remote_task",
                },
                {
                    id: 106,
                    name: 'shares',
                    icon: 'shares',
                    path: "/mc_project/shares",
                },
                {
                    id: 107,
                    name: 'emailTransfer',
                    icon: 'emailTransfer',
                    path: "/mc_project/email_transfer",
                }
            ],
            
        },
        {
            id: 2,
            name: "Instagram",
            menus: [
                {
                    id: 200,
                    name: 'taskList',
                    icon: 'taskList2',
                    path: "/mc_project/image_saver_task",
                    hasNewNum: 'getUnfinishImageSaverTaskCountIns',
                },
                {
                    id: 201,
                    name: 'instagramDownload',
                    icon: 'imageSaver',
                    path: "/mc_project/image_saver_ins",
                }
            ],
            isNew: true,
        },
        // {
        //     id: 3,
        //     name: "Video",
        //     menus: [
        //         {
        //             id: 300,
        //             name: 'taskList',
        //             icon: 'taskList2',
        //             path: "/mc_project/video_saver_task",
        //         },
        //         {
        //             id: 301,
        //             name: 'videoDownload',
        //             icon: 'videoSaver',
        //             path: "/mc_project/video_saver",
        //             isNew: true,
        //         }
        //     ]
        // },
        // {
        //     id: 4,
        //     name: "Web",
        //     menus: [
        //         {
        //             id: 400,
        //             name: 'taskList',
        //             icon: 'taskList2',
        //             path: "/mc_project/image_saver_task",
        //         },
        //         {
        //             id: 401,
        //             name: 'webDownload',
        //             icon: 'webDownload',
        //             path: "/mc_project/image_saver_web",
        //             isNew: true,
        //         }
        //     ]
        // }
    ];
const addMenuOptions = [
    {
        id: 901,
        name: "addCloud",
        icon: 'addCloudIcon',
        path: "/mc_project/add_cloud",
    },
    {
        id: 902,
        name: "addEmail",
        icon: 'addEmailIcon',
        path: "/mc_project/add_email",
    },
    {
        id: 903,
        name: "team",
        icon: 'team-white-small',
        path: "/mc_project/subAccountTeam",
    }
]
export default {
    getTabCategories() {
        let newOptions = [];
        menuOptions.forEach(option => {
            let newOption = {
                id: option.id,
                name: option.name,
                icon: option.icon,
            }
            if(option.isNew) {
                newOption.isNew = option.isNew;
            }
            newOptions.push(newOption);
        });
        return newOptions;
    },
    getMenuOptions(id) {
        let newOptions = [];
        let options = menuOptions.find(options => options.id == id);
        if(options) {
            newOptions = options.menus;
        }
        return newOptions;
    },
    jumpToPage(options,parameter) {
        if(options) {
            //跳转对应页面
            this.$router.push(options.path);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/workspace/menu_controller.js